import React from "react";
import { Box, Button, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  IDataTableProps,
  RenderType,
} from "../../../../../../components/Table/interfaces/IDataTableProps";
import { DataTable } from "../../../../../../components/Table/DataTable";
import { IBusinessPolicyToolFloater } from "../../../../../../redux/businessPolicy/businessPolicyToolFloater/businesPolicyToolFloater.types";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useSelector } from "react-redux";
import { useDispatchWrapper } from "../../../../../../hooks";
import { fetchBusinessPolicyToolFloaterListAsync } from "../../../../../../redux/businessPolicy/businessPolicyToolFloater/businessPolicyToolFloaterActions";
import { LoadState } from "../../../../../../constants/enums";
import { StandardTableActions } from "../../../../../../components/StandardTableActions/StandardTableActions";
import { CustomLink } from "../../../../../../components/CustomLink/CustomLink";

export const ToolFloaterList: React.FC<{
  customerId: number;
  customerPolicyId: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const navigate = useNavigate();
  const { data, loading } = useSelector(
    (storeState: IStoreState) => storeState.business.toolFloater
  );

  const dispatch = useDispatchWrapper();

  React.useEffect(() => {
    dispatch(fetchBusinessPolicyToolFloaterListAsync(customerPolicyId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerPolicyId]);

  const toolFloaterTableProps: IDataTableProps = {
    isPagination: false,
    isDataLoading: loading === LoadState.InProgress,
    tableCommandBarProps: {
      leftItems: {},
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <Button
                variant="contained"
                onClick={() => {
                  navigate(
                    `/business-policy/${customerId}/schedule-tab/${customerPolicyId}/tool-floater/`
                  );
                }}
              >
                Add Tool Floater
              </Button>
            ),
          },
        ],
      },
    },
    columns: [
      {
        key: "tool_floater_number",
        headerName: "#",
        fieldName: "incremental_number",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,
        onRowCellRender: (value, row: IBusinessPolicyToolFloater) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => {
                navigate(
                  `/business-policy/${customerId}/schedule-tab/${customerPolicyId}/tool-floater/${row.incremental_number}`
                );
              }}
            >
              {row.incremental_number}
            </Link>
          );
        },
      },



      {
        key: "effective_date",
        headerName: "Effective Date",
        fieldName: "effective_date",
        renderType: RenderType.DATE_DARK_COLOR,
        exportCellWidth: 20,
      },


      {
        key: "serial_number",
        headerName: "Serial Number",
        fieldName: "serial_number",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
        onRowCellRender: (value, row: IBusinessPolicyToolFloater) => {
          return (
            <CustomLink
              to={`/business-policy/${customerId}/schedule-tab/${customerPolicyId}/tool-floater/${row.incremental_number}`}
              label={row.serial_number}
            />
          );
        },
      },
      {
        key: "limit_amount",
        headerName: "Limit Amount",
        fieldName: "limit_amount",
        exportCellWidth: 25,
        renderType: RenderType.TEXT,
      },

      {
        key: "purchase_date",
        headerName: "Purchase Date",
        fieldName: "purchase_date",
        renderType: RenderType.DATE,
        exportCellWidth: 20,
      },
      {
        key: "tool_floater_submission_checkbox",
        headerName: "Submission",
        fieldName: "tool_floater_submission_checkbox",
        renderType: RenderType.TEXT,
        exportCellWidth: 20,
      },

      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: 'center',
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IBusinessPolicyToolFloater) => {
          return (
            <StandardTableActions
              //onViewClick={() => setOpenView(row)}
              onEditClick={() => {
                navigate(
                  `/business-policy/${customerId}/schedule-tab/${customerPolicyId}/tool-floater/${row.incremental_number}`
                );
              }}
            //  more={{ menuItems: menuItems }}
            />
          );
        },
      },
    ],
    items: data,
  };

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <DataTable {...toolFloaterTableProps} />
      </Box>
    </>
  );
};
